import React, { Component } from 'react'
import './index.css'
import IconClose from "../IconClose";
import { fontColourCalculator } from '../../slice/lucket-model/model';
import { Tooltip } from '@mui/material';
import { countDoneBucketsForBucket } from '../../slice/lucket-model/countBuckets';
import { STATUS_OPTION_HEX_PALLETE } from '../../constants';

const colorFloatClass = (color) => "LucketActionStatusIcon statusfloat-" + color;

class LucketWeekActionStatusIcon extends Component {

    state = {
        edit: false
    }


    edit = () => {
        if (this.state.edit === false) {
            this.setState({ edit: true })
        } else {
            this.setState({ edit: false })
        }

    }

    set = (event, v) => {
        event.stopPropagation();
        this.setState({ edit: false });
        this.props.updateLucket(v, "weekActionStatus", this.props.childLucket && this.props.lucket, this.props.childLucketIndex);
    }

    setPoints = (event, v) => {
        event.stopPropagation();
        if (v === "plus") {
            let lucket = this.props.lucket;
            if (Number(lucket.weekPoints) < 25) {
                let numPoint = Number(lucket.weekPoints);

                numPoint += 1;
                this.props.updateLucket(numPoint, "weekPoints", this.props.childLucket && this.props.lucket, this.props.childLucketIndex);
            }
        }
        if (v === "minus") {
            let lucket = this.props.lucket;
            if (Number(lucket.weekPoints) > 1) {
                let numPoint = Number(lucket.weekPoints);
                numPoint -= 1;
                this.props.updateLucket(numPoint, "weekPoints", this.props.childLucket && this.props.lucket, this.props.childLucketIndex);
            }
        }
    }

    render() {


        let options = ['blue', 'green', 'white', 'yellow', 'red', 'purple', 'black'];


        return (<Tooltip title="Week Action Status" placement='top'>
            <div className={'LucketWeekActionStatusIcon ' + 'statusfloat'}
                onClick={this.edit}
                style={{
                    color: fontColourCalculator(this.props.lucket.weekActionStatus),
                    backgroundColor: STATUS_OPTION_HEX_PALLETE[this.props.lucket.weekActionStatus]
                }}
            >
                {this.props.countWeekDonePoints}
                -
                {this.props.lucket.weekPoints}


                {(this.state.edit === true) ?
                    <div className="WeekActionStatusEditorWrapper">
                        <div className="ActionStatusCallout" />
                        <div id="menu" className="ActionStatusMenu">
                            {options.filter(
                                o => o !== this.props.lucket.weekActionStatus
                            ).map(o =>
                                <div key={o} className={'LucketActionStatusIcon ' + 'statusfloat'}
                                    style={{ backgroundColor: STATUS_OPTION_HEX_PALLETE[o] }}
                                    onClick={(e) => this.set(e, o)} />
                            )}

                            <div key={"minus"} className={'LucketActionStatusIcon ' + colorFloatClass("minus")}
                                onClick={(e) => this.setPoints(e, "minus")} >
                                <img src={"/images/minus.svg"} className="ActionStatusImage" alt="minus.svg" />
                            </div>


                            <div key={"plus"} className={'LucketActionStatusIcon ' + colorFloatClass("plus")}
                                onClick={(e) => this.setPoints(e, "plus")} >
                                <img src={"/images/add.svg"} className="ActionStatusImage" alt="add.svg" />
                            </div>

                            <IconClose edit={this.edit} key={"close"} />

                        </div></div> : null}


            </div>
        </Tooltip>)
    }

}

export default LucketWeekActionStatusIcon